module.exports = __webpack_public_path__ + "assets/img/43.7d709742.png";